import { postRequest } from 'utils/request';

// eslint-disable-next-line import/prefer-default-export
export const createTestOrder = (data) => postRequest('/test-orders/', data);
